<template>
  <div class="ma-4">
    <span
      >There are currently no {{ districtType }} district
      proposals</span
    >
  </div>
</template>

<script>
export default {
  name: "SideBPlaceholder",
  computed: {
    districtType: function () {
      const displayname = this.$mainConfig.state["body-display-names"];
      return displayname[this.$store.getters.getActiveDistrictType];
    },
  },
};
</script>

<style>
</style>